exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-arenas-arena-mangled-tsx": () => import("./../../../src/pages/arenas/{arena.mangled}.tsx" /* webpackChunkName: "component---src-pages-arenas-arena-mangled-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

